import React from "react";
import Dialog from "@mui/material/Dialog";
import { useTranslation } from "react-i18next";
import { Alert, Button, DialogActions, DialogContent, DialogTitle, styled } from "@mui/material";

import { RESOURCES_KEYS } from "utils/i18n/resources";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

interface IDialogAlertMessageProps {
  isDialogOpen: boolean;
  isWakeLockEnabled: boolean;
  onOpenDialog: (isOpen: boolean) => void;
  onChangeWakeUp: () => void;
}

const NoSleeepDialog: React.FunctionComponent<IDialogAlertMessageProps> = ({
  isWakeLockEnabled,
  isDialogOpen,
  onOpenDialog,
  onChangeWakeUp,
}) => {
  const { t: translate } = useTranslation();

  const handleClose = React.useCallback(() => onOpenDialog(false), [onOpenDialog]);

  return (
    <BootstrapDialog
      open={isDialogOpen}
      disableEscapeKeyDown
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Information</DialogTitle>
      <DialogContent>
        {isWakeLockEnabled ? (
          <Alert color="success">{translate(RESOURCES_KEYS.DIALOG_DOWNLOADING_DOCS_DONE)}</Alert>
        ) : (
          <Alert color="warning">{translate(RESOURCES_KEYS.DIALOG_NO_SLEEP_MESSAGE)}</Alert>
        )}
      </DialogContent>
      <DialogActions>
        {!isWakeLockEnabled && <Button onClick={handleClose}>{translate(RESOURCES_KEYS.NO)}</Button>}
        <Button onClick={onChangeWakeUp}>
          {!isWakeLockEnabled ? translate(RESOURCES_KEYS.YES) : translate(RESOURCES_KEYS.CLOSE)}
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default NoSleeepDialog;
